import { useState, useEffect, useCallback } from "react";

export const QUOTA_CELL_DEBOUNCE_MS = 250;

export function formatQuotaCellDisplay(value) {
	if (value === "-") return "-";
	if (value === undefined || value === null || value === "") return "";
	const n = Number(value);
	if (Number.isNaN(n)) return "";
	return n.toLocaleString("en-US");
}

/** Raw editable string while focused (no locale formatting). */
export function draftFromQuotaCellValue(value) {
	if (value === "-") return "-";
	if (value === undefined || value === null || value === "") return "";
	const n = Number(value);
	if (Number.isNaN(n)) return "";
	return String(n);
}

/**
 * Keeps local draft while focused so debounced grid updates do not overwrite fast typing.
 */
export function useQuotaCellInputSync(externalValue) {
	const [draft, setDraft] = useState(() =>
		draftFromQuotaCellValue(externalValue)
	);
	const [isFocused, setIsFocused] = useState(false);

	useEffect(() => {
		if (!isFocused) {
			setDraft(draftFromQuotaCellValue(externalValue));
		}
	}, [externalValue, isFocused]);

	const onFocus = useCallback(() => {
		setDraft(draftFromQuotaCellValue(externalValue));
		setIsFocused(true);
	}, [externalValue]);

	const onBlur = useCallback(() => {
		setIsFocused(false);
	}, []);

	const displayValue = isFocused
		? draft
		: formatQuotaCellDisplay(externalValue);

	return {
		draft,
		setDraft,
		displayValue,
		onFocus,
		onBlur,
		isFocused,
	};
}
